// API URLs configuration
const apiVersion = import.meta.env.VITE_API_VERSION || 'v1';

export const API_URLS = {
  expenses: import.meta.env.VITE_EXPENSES_WORKER_URL || 'https://expenses-worker.ltv-space.workers.dev',
  categories: import.meta.env.VITE_CATEGORIES_WORKER_URL || 'https://categories-worker.ltv-space.workers.dev',
  report: import.meta.env.VITE_REPORT_WORKER_URL || 'https://report-worker.ltv-space.workers.dev'
}

export const API_VERSION = apiVersion; 